import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { useCallback, useEffect } from 'react';

import { type QueryStateSchema, backwardsCompatabilityFactory, queryParam, queryStateParser } from './queryStateParser';

const QS_KEY = 'paneSubmissionAttemptId';
const QS_TYPE: QueryStateSchema['type'] = 'submissionAttempt';

/** Closes the submission attempt pane matching the given ID (or all submission attempt panes if no ID). */
export const useCloseSubmissionAttemptPane = (): ((submissionAttemptId?: string) => void) => {
  const [, setState] = useQueryState(queryParam, queryStateParser);
  return useCallback(
    (submissionAttemptId?: string) => {
      setState((previousState) =>
        previousState
          ? previousState.filter(
              (pane) => !(pane.type === QS_TYPE && (!submissionAttemptId || pane.id === submissionAttemptId)),
            )
          : null,
      );
    },
    [setState],
  );
};

export const useOpenSubmissionAttemptPane = (): ((args: { submissionAttemptId: string }) => void) => {
  const [submissionAttemptIdDeprecated, setSubmissionAttemptId] = useQueryState(QS_KEY, { history: 'push' });
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (submissionAttemptIdDeprecated) {
      setSubmissionAttemptId(null);
      setState(backwardsCompatabilityFactory({ id: submissionAttemptIdDeprecated, type: QS_TYPE }));
    }
  }, [submissionAttemptIdDeprecated]);

  return ({ submissionAttemptId }) => {
    setState((prevState) => [
      ...(prevState || []),
      {
        id: submissionAttemptId,
        key: nanoid(),
        type: QS_TYPE,
      },
    ]);
  };
};
